var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"fl-post-grid-title"},[_c('a',{attrs:{"href":_vm.postObj.link,"target":_vm.hrefTarget}},[_vm._v("\n           "+_vm._s(_vm.postObj.title)+"\n       ")])])}
var staticRenderFns = []

export { render, staticRenderFns }